(function () {
  angular
    .module("akitabox.mobile.directives.textCard")
    .controller("TextCardDialogController", TextCardDialogController);

  /* @ngInject */
  function TextCardDialogController($mdDialog, ToastService) {
    var self = this;

    // attributes
    self.saving = false;

    // functions
    self.cancel = $mdDialog.cancel;
    self.save = save;

    function save() {
      self.saving = true;
      self
        .update(self.ngModel)
        .then(function () {
          $mdDialog.hide();
        })
        .catch(function (err) {
          ToastService.showError(err);
        })
        .finally(function () {
          self.saving = false;
        });
    }
  }
})();
